export default function VPNService() {
  return (
    <section id="vpn-service" className="bg-[#f8f8f6] py-40">
      <div className="max-w-[1280px] mx-auto px-20">
        <div className="flex items-center gap-20">
          <div className="w-[40%]">
            <div className="rounded-3xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.08)] transform hover:scale-105 transition-transform duration-500">
              <img
                src="https://public.readdy.ai/ai/img_res/9545e07dd0d696b1056a6a2d362160f7.jpg"
                alt="VPN Network Visualization"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-[60%] pr-32">
            <div className="inline-block mb-12">
              <span className="text-xs font-bold text-[#0066ff] tracking-[3px] uppercase">
                CORE FEATURES
              </span>
            </div>
            
            <h2 className="text-5xl font-bold text-[#1a1a1a] mb-8 leading-tight">
              Military-Grade Encryption<br />Meets Seamless Performance
            </h2>
            
            <p className="text-lg text-[#666666] leading-relaxed mb-6">
              SAID LTDA provides cutting-edge VPN technology that ensures your online activities remain completely private and secure. Our advanced encryption protocols protect your data from prying eyes while maintaining lightning-fast connection speeds.
            </p>
            
            <p className="text-lg text-[#666666] leading-relaxed mb-6">
              Whether you're browsing, streaming, or conducting business online, our VPN service creates an impenetrable shield around your digital presence. Experience true internet freedom without compromising on speed or reliability.
            </p>
            
            <p className="text-lg text-[#666666] leading-relaxed">
              With servers strategically located worldwide, you can access content from anywhere while keeping your real location hidden. Your privacy is our priority, and we never log your online activities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
